import axios from 'axios';
import store from '../store';

/**
 * 创建自定义 axios 实例
 * @param {string} baseURL - 自定义的 baseURL
 * @returns {object} axios 实例
 */
export function createCustomAxios(baseURL) {
    console.log('创建自定义 axios 实例222222：', baseURL);
    const instance = axios.create({
        baseURL,
        timeout: 30000,
    });

    // 请求拦截器 - 添加 token
    instance.interceptors.request.use(
        config => {
            config.headers.token = store.state.token || '';
            return config;
        },
        error => Promise.reject(error),
    );

    // 响应拦截器 - 处理响应
    instance.interceptors.response.use(
        res => {
            // 如果返回的 code 是 1003，表示登录过期
            if (res.data && res.data.code === 1003) {
                store.dispatch('unstoreUser');
                return Promise.reject(new Error('登录过期，请重新登录'));
            }
            return res.data;
        },
        error => Promise.reject(error),
    );

    return instance;
}

/**
 * GET 请求
 * @param {string} baseURL - 自定义的 baseURL
 * @param {string} url - 请求路径
 * @param {object} params - 查询参数
 * @param {object} config - 额外的请求配置
 */
export function customGet(baseURL, url, params = {}, config = {}) {
    const instance = createCustomAxios(baseURL);
    return instance.get(url, {
        params,
        ...config,
    });
}

/**
 * POST 请求 (application/json)
 * @param {string} baseURL - 自定义的 baseURL
 * @param {string} url - 请求路径
 * @param {object} data - 请求数据
 * @param {object} config - 额外的请求配置
 */
export function customPost(baseURL, url, data = {}, config = {}) {
    const instance = createCustomAxios(baseURL);
    return instance.post(url, data, config);
}

/**
 * POST 请求 (application/x-www-form-urlencoded)
 * @param {string} baseURL - 自定义的 baseURL
 * @param {string} url - 请求路径
 * @param {object} data - 请求数据
 * @param {object} config - 额外的请求配置
 */
export function customPostForm(baseURL, url, data = {}, config = {}) {
    const instance = createCustomAxios(baseURL);
    // 转换为 form-urlencoded 格式
    const formData = new URLSearchParams();
    for (let key in data) {
        formData.append(key, data[key]);
    }
    return instance.post(url, formData, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        ...config,
    });
}

/**
 * PUT 请求
 * @param {string} baseURL - 自定义的 baseURL
 * @param {string} url - 请求路径
 * @param {object} data - 请求数据
 * @param {object} config - 额外的请求配置
 */
export function customPut(baseURL, url, data = {}, config = {}) {
    const instance = createCustomAxios(baseURL);
    return instance.put(url, data, config);
}

/**
 * DELETE 请求
 * @param {string} baseURL - 自定义的 baseURL
 * @param {string} url - 请求路径
 * @param {object} config - 额外的请求配置
 */
export function customDelete(baseURL, url, config = {}) {
    const instance = createCustomAxios(baseURL);
    return instance.delete(url, config);
}
